import { request } from "@erinfo/provider/src/data/request"
import { validateFaceImg } from "@erinfo/react-utils/src/helpers/validate-face-img"

export const validationCallback = validateFaceImg(request, false, true)
export const validationCallbackDuplicateOk = validateFaceImg(request, true)
